{
  "login": {
    "genericError": "An error occurred during login. Please try again."
  },
  "acceptTerms": {
    "pleaseAccept": "Please accept the Terms and Conditions to continue",
    "accepted": "Terms and Conditions accepted",
    "failedGeneric": "Failed to accept terms. Please try again."
  },
  "discord": {
    "linkSuccess": "Discord account linked! Please verify your DMs below.",
    "linkFailed": "Failed to link Discord account: {{message}}",
    "verificationSent": "Verification code sent to your Discord DMs!",
    "dmVerified": "Discord DMs verified successfully! Notifications are now available.",
    "settingToggled": "{{label}} {{state}}",
    "unlinked": "Discord account unlinked successfully!",
    "userIdNotFound": "User ID not found. Please try logging in again.",
    "clientIdNotConfigured": "Discord Client ID not configured. Check your environment variables.",
    "redirectUriNotConfigured": "Redirect URL not properly configured. Check your environment variables.",
    "allowPopups": "Please allow popups for this site to link your Discord account",
    "linkFirst": "Please link your Discord account first",
    "sendCodeFailed": "Failed to send verification code. Make sure the bot can DM you.",
    "sendCodeFailedGeneric": "Failed to send verification code",
    "enterCode": "Please enter the verification code",
    "verifyCodeFailed": "Failed to verify code. Please try again.",
    "verifyFirst": "Please verify your Discord DMs first",
    "updateSettingFailed": "Failed to update notification setting",
    "unlinkFailed": "Failed to unlink Discord account",
    "categoryUpdated": "Category updated",
    "categoryUpdateFailed": "Failed to update category",
    "categoryDeleted": "Category deleted",
    "categoryDeleteFailed": "Failed to delete category",
    "defaultCategoryUpdated": "Default category updated",
    "setDefaultFailed": "Failed to set default category",
    "categoryCreated": "Category created",
    "categoryCreateFailed": "Failed to create category"
  },
  "subscription": {
    "failedLoadPricing": "Failed to load pricing information",
    "failedCheckout": "Failed to initiate checkout",
    "failedChangeSubscription": "Failed to change subscription",
    "failedOpenBillingPortal": "Failed to open billing portal",
    "cancelSuccess": "Your subscription has been successfully canceled",
    "cancelFailed": "Failed to cancel subscription",
    "resumeSuccess": "Your subscription has been successfully resumed",
    "resumeFailed": "Failed to resume subscription",
    "updateSuccess": "Your subscription has been updated!",
    "newSubscriptionSuccess": "Welcome! Your subscription is now active."
  },
  "trial": {
    "activated": "Trial activated! Enjoy 7 days of FlippingPal.",
    "activationFailed": "Failed to activate trial"
  },
  "account": {
    "emailBothFieldsRequired": "Please fill in both fields",
    "emailInvalid": "Please enter a valid email address",
    "emailUpdated": "Email updated! Please check your new email to confirm. Logging out...",
    "emailFailed": "Failed to change email",
    "passwordAllFieldsRequired": "Please fill in all password fields",
    "passwordTooShort": "New password must be at least 4 characters",
    "passwordsDoNotMatch": "New passwords do not match",
    "passwordChanged": "Password changed successfully!",
    "passwordFailed": "Failed to change password",
    "closeAccountPasswordRequired": "Please enter your password",
    "closeAccountConfirmRequired": "Please type \"CLOSE MY ACCOUNT\" to confirm",
    "accountClosed": "Account closed. Logging out...",
    "closeAccountFailed": "Failed to close account"
  },
  "snipe": {
    "ilvlEnterAtLeastOne": "Please enter at least one of min ilvl or max ilvl",
    "ilvlValidMin": "Please enter a valid min ilvl",
    "ilvlValidMax": "Please enter a valid max ilvl",
    "ilvlMinExceedsMax": "Min ilvl cannot exceed {{max}}",
    "ilvlMaxExceedsMax": "Max ilvl cannot exceed {{max}}",
    "ilvlMinGreaterThanMax": "Min ilvl cannot be greater than max ilvl",
    "ilvlValidPrice": "Please enter a valid price (e.g. 100g, 50g 30s, or 100)",
    "reqLvlMinRange": "Required min level must be between {{min}} and {{max}}",
    "reqLvlMaxRange": "Required max level must be between {{min}} and {{max}}",
    "reqLvlMinGreaterThanMax": "Required min level cannot be greater than required max level",
    "ilvlAdded": "ilvl snipe added",
    "ilvlUpdated": "ilvl snipe updated",
    "ilvlSaveFailed": "Failed to save ilvl snipe",
    "ilvlRemoved": "ilvl snipe removed",
    "ilvlRemoveFailed": "Failed to remove ilvl snipe",
    "selectItem": "Please select an item",
    "validPetId": "Please enter a valid Pet ID or search for a pet",
    "invalidPrice": "Please enter a valid price (e.g. 100g, 50g 30s, or 100)",
    "itemAdded": "Snipe {{label}} added",
    "itemUpdated": "Snipe {{label}} updated",
    "itemAddFailed": "Failed to add snipe {{type}}",
    "itemRemoved": "Snipe {{type}} removed",
    "itemRemoveFailed": "Failed to remove snipe {{type}}",
    "editingWoWToken": "Editing WoW Token snipe alert",
    "editingSnipeAlert": "Editing snipe alert for {{name}}",
    "itemNotFound": "{{label}} not found.",
    "importInvalidArrayFormat": "Invalid format. Expected an array of ilvl snipe rules.",
    "importNoValidEntries": "No valid entries found. Array items need \"{{idKey}}\" and \"price\" fields.",
    "importInvalidJsonFormat": "Invalid JSON format. Expected { {{idKey}}: goldPrice, ... } or an array of objects.",
    "importSuccess": "Import: {{added}} added, {{updated}} updated, {{skipped}} skipped",
    "importIlvlSuccess": "Imported {{count}} ilvl snipe rule(s)",
    "importParseFailed": "Failed to parse or import JSON",
    "noItemsToExport": "No {{type}} to export",
    "noIlvlItemsToExport": "No ilvl items to export",
    "exportSuccess": "Exported {{count}} {{type}}",
    "exportIlvlSuccess": "Exported {{count}} ilvl items",
    "enabledToggle": "Snipe alerts {{state}}",
    "enabledToggleFailed": "Failed to update snipe setting",
    "alertStyleUpdated": "Alert style set to {{style}}",
    "alertStyleFailed": "Failed to update alert style",
    "realmsSaved": "Snipe realms saved",
    "realmsSaveFailed": "Failed to save snipe realms",
    "clearAllConfirm": "Are you sure you want to remove all snipe {{label}}?",
    "clearAllSuccess": "All snipe {{label}} cleared",
    "clearAllFailed": "Failed to clear snipe {{label}}",
    "cooldownCyclesUpdated": "Alert cooldown set to {{cycles}} skipped cycle(s)",
    "cooldownCyclesFailed": "Failed to update alert cooldown",
    "cooldownCyclesInvalid": "Cooldown must be between 0 and 24 cycles",
    "undo": "Undo",
    "undoRestored": "Snipe alert restored",
    "undoFailed": "Failed to restore snipe alert",
    "priceUpdated": "Price updated",
    "priceUpdateFailed": "Failed to update price"
  },
  "personalConfig": {
    "saveSuccess": "Filter defaults saved successfully!",
    "saveFailed": "Failed to save filter defaults"
  },
  "auth": {
    "registrationSuccessEmail": "Registration successful! Please check your email for verification.",
    "registrationSuccessLogin": "Registration successful! Please log in with your new account.",
    "passwordResetSuccess": "Password reset successfully"
  },
  "common": {
    "networkError": "Network error. Please try again."
  },
  "validation": {
    "passwordRequired": "Password is required",
    "passwordMinLength": "Password must be at least {{count}} characters long",
    "passwordUppercase": "Password must contain at least one uppercase letter",
    "passwordLowercase": "Password must contain at least one lowercase letter",
    "passwordNumber": "Password must contain at least one number",
    "passwordSpecialChar": "Password must contain at least one special character",
    "confirmPasswordRequired": "Please confirm your password",
    "passwordsDoNotMatch": "Passwords do not match",
    "emailRequired": "Email is required",
    "emailInvalid": "Please enter a valid email address"
  },
  "filterPreset": {
    "fetchFailed": "Failed to fetch filter presets",
    "createFailed": "Failed to create filter preset",
    "updateFailed": "Failed to update filter preset",
    "deleteFailed": "Failed to delete filter preset",
    "invalidImportNotObject": "Invalid import string: Not a valid preset object",
    "invalidImportMissingVersion": "Invalid import string: Missing version information",
    "invalidImportMissingPreset": "Invalid import string: Missing preset data",
    "invalidPresetMissingName": "Invalid preset: Missing or invalid name",
    "invalidPresetMissingFilters": "Invalid preset \"{{name}}\": Missing or invalid filters"
  }
}
